import "vue-class-component/hooks";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import pack from "../package.json";

import "@/plugins/element.js";

import "@/less/index.less";

/**
 * Amplify
 */
import "@aws-amplify/ui-vue";
import Amplify from "aws-amplify";
import awsconfig from "@/aws-exports.js";
import "@/plugins/auth";

Amplify.configure(awsconfig);

console.log("EBI::Main::Version", pack.version);

/**
 * Vue Plugins
 */
import VueMeta from "vue-meta";
Vue.use(VueMeta);


/**
 * Vue Main
 */

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
	created: () => {
		// window.setTimeout(() => {
		// 	store.commit("setLoaded");
		// }, 250);
	},
}).$mount("#app");
